import React from 'react';
import { CountdownTimer } from './CountdownTimer';
const comparisonRows = [{
  without: '❌ 100h/Jahr Planung von Null',
  with: '✅ 5 Min/Woche. Alles fertig.'
}, {
  without: '❌ Übungen ohne roten Faden',
  with: '✅ Logische, messbare Progression'
}, {
  without: '❌ Unruhige Schüler',
  with: '✅ Höchste Motivation durch Abwechslung'
}, {
  without: '❌ Zettelwirtschaft',
  with: '✅ Klare Struktur & Dokumentation'
}];
const offer = {
  emoji: '🏆',
  title: 'BASKETBALL BEREIT 360',
  description: '6 Bände + 5 Boni',
  originalPrice: '90 €',
  price: '19 €',
  ctaText: '🏃 JA, ICH WILL MEINEN JAHRESPLANER',
  ctaHref: 'https://basketball-bereit.impultienda.ar/checkout',
  savings: 'SPARE 71 €'
};
export function FinalCTA() {
  return <section className="w-full bg-[#0A0A0A] py-20 px-4" data-id="element-46">
      <div className="max-w-2xl mx-auto" data-id="element-47">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-white text-center mb-8 tracking-tight leading-tight" data-id="element-48">
          Hören Sie auf zu improvisieren. <br className="hidden md:block" data-id="element-49" />
          <span className="text-[#FF6B00]" data-id="element-50">Starten Sie mit System.</span>
        </h2>

        <p className="text-[#B0B0C0] text-center text-base sm:text-lg font-medium mb-12 max-w-xl mx-auto" data-id="element-51">
          Schließen Sie sich hunderten Lehrern und Trainern an, die ihr gesamtes
          Jahr in unter 5 Minuten planen.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-6 text-white font-bold text-sm sm:text-base mb-12 uppercase tracking-wider" data-id="element-52">
          <span data-id="element-53">Einheiten.</span>
          <span className="text-[#333]" data-id="element-54">/</span>
          <span data-id="element-55">Drills.</span>
          <span className="text-[#333]" data-id="element-56">/</span>
          <span data-id="element-57">Progression.</span>
          <span className="text-[#333]" data-id="element-58">/</span>
          <span data-id="element-59">Bewertung.</span>
          <span className="text-[#333]" data-id="element-60">/</span>
          <span className="text-[#00C853]" data-id="element-61">Alles organisiert.</span>
        </div>

        <div className="bg-[#16161F] border border-[#FF6B0033] rounded-2xl overflow-hidden mb-12 shadow-2xl" data-id="element-62">
          <div className="grid grid-cols-2 bg-[#0A0A0A] border-b border-[#FF6B0033]" data-id="element-63">
            <div className="px-4 py-4 font-black text-[#B0B0C0] text-xs sm:text-sm text-center uppercase tracking-wider" data-id="element-64">
              Ohne Basketball Bereit
            </div>
            <div className="px-4 py-4 font-black text-[#FF6B00] text-xs sm:text-sm text-center border-l border-[#FF6B0033] uppercase tracking-wider" data-id="element-65">
              Mit Basketball Bereit 360
            </div>
          </div>
          {comparisonRows.map((row, i) => <div key={i} className={`grid grid-cols-2 ${i < comparisonRows.length - 1 ? 'border-b border-[#FF6B0033]' : ''}`} data-id="element-66">
              <div className="px-4 py-4 text-[#B0B0C0] text-xs sm:text-sm font-medium" data-id="element-67">
                {row.without}
              </div>
              <div className="px-4 py-4 text-white font-bold text-xs sm:text-sm bg-[#FF6B00]/5 border-l border-[#FF6B0033]" data-id="element-68">
                {row.with}
              </div>
            </div>)}
        </div>

        <div className="text-center mb-8" data-id="element-69">
          <CountdownTimer size="md" blinking={true} data-id="element-70" />
        </div>

        <div className="max-w-xl mx-auto mb-8" data-id="element-71">
          <div className="relative bg-[#16161F] border-2 border-[#FF6B00] rounded-2xl p-6 shadow-[0_0_40px_rgba(255,107,0,0.15)] overflow-hidden" data-id="element-72">
            <div className="absolute top-0 right-0 bg-[#FF6B00] text-white text-[10px] font-black px-3 py-1 rounded-bl-xl uppercase tracking-wider" data-id="element-73">
              🏆 KOMPLETTE BIBLIOTHEK
            </div>

            <div className="flex items-center gap-2 mb-2 mt-3 sm:mt-0" data-id="element-74">
              <span className="text-xl" data-id="element-75">{offer.emoji}</span>
              <span className="text-white font-black text-base sm:text-lg tracking-tight" data-id="element-76">
                {offer.title}
              </span>
            </div>
            <p className="text-[#B0B0C0] text-sm font-medium mb-5" data-id="element-77">
              {offer.description}
            </p>

            <div className="flex items-end justify-between" data-id="element-78">
              <div data-id="element-79">
                <div className="text-[#B0B0C0] line-through text-sm font-bold mb-1" data-id="element-80">
                  Statt {offer.originalPrice}
                </div>
                <div className="font-black text-4xl sm:text-5xl text-white tracking-tighter leading-none" data-id="element-81">
                  Jetzt nur {offer.price}
                </div>
              </div>
              <span className="inline-block bg-[#00C853]/15 text-[#00C853] text-xs font-black px-3 py-1.5 rounded-full uppercase tracking-wider" data-id="element-82">
                {offer.savings}
              </span>
            </div>
          </div>
        </div>

        <div className="max-w-xl mx-auto" data-id="element-83">
          <a href={offer.ctaHref} className="btn-cta-green block w-full text-center font-black text-lg sm:text-2xl py-6 rounded-2xl transition-colors shadow-2xl mb-6" data-id="element-84">
            {offer.ctaText}
          </a>

          <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 text-xs sm:text-sm text-[#B0B0C0] font-bold" data-id="element-85">
            <span className="flex items-center gap-1.5" data-id="element-86">
              🔒 Sicherer SSL-Check-out
            </span>
            <span className="flex items-center gap-1.5" data-id="element-87">
              ⚡ Sofortiger Zugriff
            </span>
            <span className="flex items-center gap-1.5" data-id="element-88">
              🛡️ 7-Tage Garantie
            </span>
            <span className="flex items-center gap-1.5" data-id="element-89">
              💳 Karten · PayPal · GooglePay
            </span>
          </div>
        </div>
      </div>
    </section>;
}